module.exports = __webpack_public_path__ + "static/media/trekcheck.1446b795.png";